<template>
    <div>
		<tab name="1"></tab>
        <div class="page-btns-box">
            <el-button
                type="primary"
                icon="el-icon-circle-plus-outline"
                @click="$router.push({name: 'addUpdateNotify', params: {appType:params.appType}})"
                v-if="$utils.have('/app/info/create')"
                size="small"
                >创建</el-button
            >
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <!-- <el-table-column label="对象类型" min-width="120">
                    <template slot-scope="scope">
                        {{scope.row.appType == 1 ? '乐迷版' : '专业版'}}
                    </template>
                </el-table-column> -->
                <el-table-column label="版本" prop="versionCode" min-width="120"></el-table-column>
                <el-table-column label="客户端" prop="title" min-width="120">
                    <template slot-scope="scope">
                        <template v-if="scope.row.versionTerminal == 1">iOS</template>
                        <template v-else-if="scope.row.versionTerminal == 2">Android</template>
                        <template v-else-if="scope.row.versionTerminal == 4">鸿蒙</template>
                    </template>
                </el-table-column>
                <el-table-column label="强制更新" prop="terminalStr" min-width="120">
                    <template slot-scope="scope">
                        {{scope.row.force ? '是' : '否' }}
                    </template>
                </el-table-column>
                <el-table-column label="通知标题" prop="versionName" min-width="270"></el-table-column>
                <el-table-column label="通知时间" prop="time" min-width="150"></el-table-column>
                <el-table-column fixed="right" label="操作" width="80">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            icon="el-icon-edit"
                            v-if="$utils.have('/app/info/getById')"
                            @click="$router.push({name: 'editUpdateNotify', params: {id: scope.row.id,appType: scope.row.appType}})"
                            >管理</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0"
            >
            </el-pagination>
        </div>
    </div>
</template>
<script>
import Tab from './components/tab'
export default {
	components: {
		Tab
	},
    data() {
        return {
            data: null,
            dataList: null,
            params: {
                pageNo:parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
				appType:1
            },
            detailData: null,
            listLoading: true
        };
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
			this.listLoading = true;
			this.$request({
				url: "/app/info/list",
				method: "POST",
				data: this.params,
			})
				.then((res) => {
					const { state, msg, result } = res.data;
					if (state == 1 && result) {
						this.data = result;
						this.dataList = result.result || [];
					} else {
						this.$message.error(msg || "请求失败");
					}
				})
				.catch(() => {
					this.$message.error("请求错误");
				})
				.finally(() => {
					this.listLoading = false;
				});
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
    },
};
</script>

